import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableScorecardDetails extends Layout {
    sourceCarrierPerformanceMetric: DataSource;
    tableScoreCardDetails: Table;
}
